import { render } from "./EmbrioIbvk.vue?vue&type=template&id=3ab1aac5"
import script from "./EmbrioIbvk.vue?vue&type=script&lang=js"
export * from "./EmbrioIbvk.vue?vue&type=script&lang=js"

import "./EmbrioIbvk.vue?vue&type=style&index=0&id=3ab1aac5&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__